<template>
  <div class="cashcreation">
    <div class="header-text" :style="{ width: ElementHeight }">
      <h1 class="header-title">积分商城商品管理—复制（礼品）</h1>
      <div class="buttom-div">
        <el-button class="push-button" @click="Createasave">保存</el-button>
        <el-button
          class="push-button"
          icon="iconfont icon-fanhui"
          @click="clearbtn"
          >返回</el-button
        >
      </div>
    </div>
    <div class="header-text1"></div>
    <div>
      <el-card shadow="never" class="card-center" style="margin-top: 10px">
        <!-- 选择礼品弹窗 -->
        <div class="choice">
          <el-dialog width="45%"
                     title="选择礼品"
                     :visible.sync="innerVisible"
                     :close-on-click-modal="false">
            <el-button icon="el-icon-search"
                       @click="Seacharbtn"
                       style="margin-left: 88%; margin-bottom: 10px; margin-top: -20px">查询</el-button>
            <el-form size="mini"
                     :label-position="labelPosition"
                     label-width="80px">
              <el-row>
                <el-col>
                  <el-form-item label="礼品编号">
                    <el-input v-model="Position.giftNo"
                              style="width: 75%"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col>
                  <el-form-item label="礼品名称">
                    <el-input v-model="Position.giftName"
                              style="width: 75%">
                    </el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
            <div style="width: 100%; margin-top: 10px">
              <el-table size="mini"
                        class="table-style"
                        border
                        :row-class-name="tableRowClassName"
                        :header-cell-style="{
                  background: '#FCFBF2',
                  color: '#6C6839',
                  'text-align': 'center',
                }"
                        :cell-style="{ 'text-align': 'center' }"
                        ref="multipleTable"
                        :data="SkuList"
                        tooltip-effect="dark"
                        v-el-table-infinite-scroll="true"
                        infinite-scroll-disabled="true">
                <el-table-column width="40">
                  <template slot-scope="scope">
                    <el-radio v-model="radioId"
                              :label="scope.$index"
                              @change.native="handleRadioChange(scope.row)">&nbsp;
                    </el-radio>
                  </template>
                </el-table-column>
                <el-table-column prop="giftNo"
                                 label="礼品编码">
                </el-table-column>
                <el-table-column prop="giftName"
                                 label="礼品名称">
                </el-table-column>
                <el-table-column prop="giftKind"
                                 label="礼品类型">
                  <template scope="scope">
                    {{
                      scope.row.giftKind === 0
                          ? "成衣"
                          : "" || scope.row.giftKind === 1
                              ? "革履"
                              : "" || scope.row.giftKind === 2
                                  ? "配饰"
                                  : "" || scope.row.giftKind === 3
                                      ? "非公司商品"
                                      : ""
                    }}
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div slot="footer"
                 class="dialog-footer">
              <el-button @click="Eacmentbtn">确 定</el-button>
              <el-button @click="innerVisible = false">取 消</el-button>
            </div>
          </el-dialog>
        </div>
        <!-- 产品信息详情查看弹窗-->
        <div class="found">
          <el-dialog
            width="60%"
            title="产品详细信息"
            :visible.sync="foundFormVisible"
            :close-on-click-modal="false"
          >
            <el-form
              size="mini"
              label-width="80px"
              :model="formLabeladd"
              ref="resberValidateForm"
              style="margin-top: 20px"
            >
              <el-row :gutter="30">
                <el-col :span="12">
                  <el-form-item label="SKU">
                    <el-input
                      v-model="formLabeladd.sku"
                      :disabled="true"
                      style="width: 100%"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="产品编码">
                    <el-input
                      placeholder=""
                      v-model="formLabeladd.productCode"
                      :disabled="true"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="30">
                <el-col :span="12">
                  <el-form-item label="SKU描述中文">
                    <el-input
                      v-model="formLabeladd.skudesc_CN"
                      :disabled="true"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="产品中文描述">
                    <el-input
                      placeholder=""
                      v-model="formLabeladd.productName_CN"
                      :disabled="true"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="30">
                <el-col :span="12">
                  <el-form-item label="SKU描述英文">
                    <el-input
                      placeholder=""
                      v-model="formLabeladd.skudesc_EN"
                      :disabled="true"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="产品名称英文" prop="otherReason">
                    <el-input
                      placeholder=""
                      v-model="formLabeladd.productName_EN"
                      :disabled="true"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="30">
                <el-col :span="12">
                  <el-form-item label="SKU描述意大利" prop="realChgDate">
                    <el-input
                      placeholder=""
                      v-model="formLabeladd.skudesc_IT"
                      :disabled="true"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="产品名称意大利" prop="remark">
                    <el-input
                      v-model="formLabeladd.productName_IT"
                      :disabled="true"
                      style="width: 100%"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="品牌编号" prop="remark">
                    <el-input
                      v-model="formLabeladd.brandNo"
                      :disabled="true"
                      style="width: 100%"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="产品描述" prop="remark">
                    <el-input
                      v-model="formLabeladd.description"
                      :disabled="true"
                      style="width: 100%"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="种类编号" prop="remark">
                    <el-input
                      v-model="formLabeladd.familyID"
                      :disabled="true"
                      style="width: 100%"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="类别编号" prop="remark">
                    <el-input
                      v-model="formLabeladd.categoryID"
                      :disabled="true"
                      style="width: 100%"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="类别" prop="remark">
                    <el-input
                      v-model="formLabeladd.category_cn"
                      :disabled="true"
                      style="width: 100%"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="款号编号" prop="remark">
                    <el-input
                      v-model="formLabeladd.styleID"
                      :disabled="true"
                      style="width: 100%"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="类别英文" prop="remark">
                    <el-input
                      v-model="formLabeladd.category_en"
                      :disabled="true"
                      style="width: 100%"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="款号附加位编号" prop="remark">
                    <el-input
                      v-model="formLabeladd.styleAddnCode"
                      :disabled="true"
                      style="width: 100%"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="产品线编号" prop="remark">
                    <el-input
                      v-model="formLabeladd.lineID"
                      :disabled="true"
                      style="width: 100%"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="主成份编号" prop="remark">
                    <el-input
                      v-model="formLabeladd.mainCompID"
                      :disabled="true"
                      style="width: 100%"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="成份" prop="remark">
                    <el-input
                      v-model="formLabeladd.composition_cn"
                      :disabled="true"
                      style="width: 100%"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="颜色编号" prop="remark">
                    <el-input
                      v-model="formLabeladd.colorID"
                      :disabled="true"
                      style="width: 100%"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="成份英文" prop="remark">
                    <el-input
                      v-model="formLabeladd.composition_en"
                      :disabled="true"
                      style="width: 100%"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="季号" prop="remark">
                    <el-input
                      v-model="formLabeladd.seasonID"
                      :disabled="true"
                      style="width: 100%"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="尺码模板编号" prop="remark">
                    <el-input
                      v-model="formLabeladd.sizeTemplateID"
                      :disabled="true"
                      style="width: 100%"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="附加信息编码" prop="remark">
                    <el-input
                      v-model="formLabeladd.addnCode"
                      :disabled="true"
                      style="width: 100%"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="模板名称" prop="remark">
                    <el-input
                      v-model="formLabeladd.templateName_cn"
                      :disabled="true"
                      style="width: 100%"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="图像文件名" prop="remark">
                    <el-input
                      v-model="formLabeladd.imgFileName1"
                      :disabled="true"
                      style="width: 100%"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="模板名称英文" prop="remark">
                    <el-input
                      v-model="formLabeladd.templateName_en"
                      :disabled="true"
                      style="width: 100%"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="图像文件名2" prop="remark">
                    <el-input
                      v-model="formLabeladd.imgFileName2"
                      :disabled="true"
                      style="width: 100%"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="设计师编号" prop="remark">
                    <el-input
                      v-model="formLabeladd.designerID"
                      :disabled="true"
                      style="width: 100%"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="大类" prop="remark">
                    <el-input
                      v-model="formLabeladd.zdl"
                      :disabled="true"
                      style="width: 100%"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="设计师姓名" prop="remark">
                    <el-input
                      v-model="formLabeladd.designerName"
                      :disabled="true"
                      style="width: 100%"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="细类" prop="remark">
                    <el-input
                      v-model="formLabeladd.zxlbm"
                      :disabled="true"
                      style="width: 100%"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="系列" prop="remark">
                    <el-input
                      v-model="formLabeladd.zxl"
                      :disabled="true"
                      style="width: 100%"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="组别" prop="remark">
                    <el-input
                      v-model="formLabeladd.groupLvl"
                      :disabled="true"
                      style="width: 100%"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="性别(产品)" prop="remark">
                    <el-input
                      v-model="formLabeladd.zwldl"
                      :disabled="true"
                      style="width: 100%"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="产地" prop="remark">
                    <el-input
                      v-model="formLabeladd.wherl"
                      :disabled="true"
                      style="width: 100%"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="货币ID" prop="remark">
                    <el-input
                      v-model="formLabeladd.currencyID"
                      :disabled="true"
                      style="width: 100%"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="状态" prop="remark">
                    <el-select
                      v-model="formLabeladd.state"
                      style="width: 100%"
                      :disabled="true"
                    >
                      <el-option
                        v-for="item in options"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="款色编码" prop="remark">
                    <el-input
                      v-model="formLabeladd.styleColorCode"
                      :disabled="true"
                      style="width: 100%"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="创建人员" prop="createUserID">
                    <el-input
                      v-model="formLabeladd.createUserName"
                      :disabled="true"
                      style="width: 100%"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="创建时间">
                    <el-time-picker
                      v-model="formLabeladd.createTime"
                      :disabled="true"
                      style="width: 100%"
                      format="yyyy-mm-dd:hh:mm"
                    >
                    </el-time-picker>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="修改人员" prop="updateUserID">
                    <el-input
                      v-model="formLabeladd.updateUserName"
                      :disabled="true"
                      style="width: 100%"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="修改时间" prop="remark">
                    <el-time-picker
                      v-model="formLabeladd.updateTime"
                      :disabled="true"
                      style="width: 100%"
                      format="yyyy-mm-dd:hh:mm"
                    >
                    </el-time-picker>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </el-dialog>
        </div>
        <!-- 礼品券库弹窗 -->
        <div class="present">
          <el-dialog
            width="40%"
            title="选择券库"
            :visible.sync="innerVisibleLier"
            :close-on-click-modal="false"
          >
            <el-form
              size="mini"
              :label-position="labelPosition"
              label-width="120px"
            >
              <el-row>
                <el-col :span="12">
                  <el-form-item label="券名称">
                    <el-input v-model="queryArr.couponsName"> </el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="券类型">
                    <div style="display: flex">
                      <el-select
                        style="width: 70%"
                        v-model="queryArr.couponsKind"
                      >
                        <el-option label="现金券" value="0"> </el-option>
                        <el-option label="折扣券" value="1"> </el-option>
                        <el-option label="礼品券" value="2"> </el-option>
                        <el-option label="异业券" value="3"> </el-option>
                      </el-select>
                      <el-button icon="el-icon-search" @click="Seachbtn"
                        >查询</el-button
                      >
                    </div>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="创建时间">
                    <el-date-picker
                      v-model="queryArr.createTime"
                      type="date"
                      placeholder="选择时间"
                      value-format="yyyy-MM-dd"
                    >
                    </el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="至">
                    <el-date-picker
                      v-model="queryArr.updateTime"
                      type="date"
                      placeholder="选择时间"
                      value-format="yyyy-MM-dd"
                    >
                    </el-date-picker>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
            <div style="width: 100%; margin-top: 10px">
              <el-table
                height="300"
                class="table-style"
                border
                :row-class-name="tableRowClassName"
                :header-cell-style="{
                  background: '#FCFBF2',
                  color: '#6C6839',
                  'text-align': 'center',
                }"
                :cell-style="{ 'text-align': 'center' }"
                ref="multipleTable"
                :data="queryList"
                tooltip-effect="dark"
              >
                <el-table-column width="40">
                  <template slot-scope="scope">
                    <el-radio
                      v-model="radioes"
                      :label="scope.$index"
                      @change.native="handleRadioChangeV(scope.row)"
                      >&nbsp;
                    </el-radio>
                  </template>
                </el-table-column>
                <el-table-column prop="couponsName" label="券名称">
                </el-table-column>
                <el-table-column prop="innerCoupName" label="券后台名称">
                </el-table-column>
                <el-table-column prop="couponsKind" label="券类型">
                  <template scope="scope">
                    {{
                      scope.row.couponsKind === 0
                        ? " 现金券"
                        : "" || scope.row.couponsKind === 1
                        ? "折扣券"
                        : "" || scope.row.couponsKind === 2
                        ? "礼品券"
                        : "" || scope.row.couponsKind === 3
                        ? "异业券"
                        : ""
                    }}
                  </template>
                </el-table-column>
                <el-table-column prop="createUserName" label="创建人">
                </el-table-column>
                <el-table-column prop="createTime" label="创建时间">
                  <template scope="scope">
                    {{ scope.row.createTime | dateFormats }}
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div slot="footer" class="dialog-footer">
              <el-button @click="determine">确 定</el-button>
              <el-button @click="innerVisibleLier = false">取 消</el-button>
            </div>
          </el-dialog>
        </div>
        <!-- 表单 -->
        <div>
          <el-form
            size="small"
            :label-position="labelPosition"
            label-width="100px"
          >
            <el-row :gutter="100">
              <el-col :span="9">
                <el-form-item label="礼品">
                  <div style="display: flex">
                    <el-input
                      v-model="ruleForm.commodityName"
                      readonly
                    ></el-input>
                    <el-button style="margin-left: 10px" @click="Earchbtn"
                      >选择礼品</el-button
                    >
                  </div>
                </el-form-item>
              </el-col>
              <el-col :span="9">
                <el-form-item label="商品名称">
                  <el-input
                    v-model="ruleForm.commodityName"
                    readonly
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="100">
              <el-col :span="9">
                <el-form-item label="礼品券库">
                  <div class="flex-between">
                    <el-input
                      v-model="ruleForm.couponsName"
                      readonly
                      @click.native="giftDaTeurl"
                    ></el-input>
                    <el-button style="margin-left: 10px" @click="SearchJuan"
                      >选择券库</el-button
                    >
                  </div>
                </el-form-item>
              </el-col>
              <el-col :span="9" style="margin-top: 50px; margin-left: -38%">
                <el-form-item label="商品详情">
                  <!-- <el-input type="textarea"
                            v-model="ruleForm.commDetail"></el-input> -->
                  <editor v-model="ruleForm.commDetail" :min-height="192" />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="100">
              <el-col :span="9">
                <el-form-item label="封面图">
                  <img
                    width="45%"
                    v-for="(item, index) in imagesArray"
                    :key="index"
                    :src="item"
                    style="margin: 10px"
                    @click="Imagedeletebtn(index)"
                  />
                  <el-upload
                    :http-request="handleImportsd"
                    :limit="3"
                    action="#"
                    list-type="picture-card"
                    style="margin-top: 10px"
                  >
                    <i class="el-icon-plus"></i>
                  </el-upload>
                </el-form-item>
              </el-col>
              <el-col :span="9"> </el-col>
            </el-row>
            <el-row :gutter="100">
              <el-col :span="9">
                <el-form-item label="颜色">
                  <el-checkbox-group v-model="colorcheckList">
                    <el-checkbox
                      name="type"
                      v-for="(item, index) in colorList"
                      :key="item.colorAttrID"
                      :label="item.colorAttrID"
                      >{{ item.colorName }}
                      <div style="width: 100%">
                        <span style="color: #c9b916"
                          >说明：最多3张图片，规格：长*宽；格式：JPG，PNG；大小：xxMB</span
                        >
                      </div>
                      <img
                        width="50%"
                        @click="remoImage(index, index2)"
                        :src="item2"
                        v-for="(item2, index2) in item.imgList"
                        :key="index2"
                        style="margin: 10px"
                      />
                      <el-upload
                        :limit="3"
                        action="#"
                        :http-request="imageupdate"
                        :data="{ index }"
                        :show-file-list="false"
                        list-type="picture-card"
                      >
                        <i class="el-icon-plus"></i>
                      </el-upload>
                    </el-checkbox>
                  </el-checkbox-group>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="18">
                <el-form-item label="SKU">
                  <el-table
                    size="mini"
                    class="table-style"
                    border
                    :row-class-name="tableRowClassName"
                    :header-cell-style="{
                      background: '#FCFBF2',
                      color: '#6C6839',
                      'text-align': 'center',
                    }"
                    :cell-style="{ 'text-align': 'center' }"
                    ref="multipleTable"
                    :data="tCommskustockList"
                    tooltip-effect="dark"
                  >
                    <el-table-column label width="35" type="index">
                    </el-table-column>
                    <el-table-column prop="productSKU" label="礼品SKU">
                      <template slot-scope="scope">
                        <div
                          style="text-decoration: underline; color: #76734f"
                          @click="handleGoods(scope.row)"
                        >
                          {{ scope.row.productSKU }}
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column prop="colorName" label="颜色">
                    </el-table-column>
                    <el-table-column prop="sizeName" label="尺码">
                    </el-table-column>
                    <el-table-column prop="stockQty" label="库存数量">
                      <template scope="scope">
                        <el-input v-model="scope.row.stockQty"></el-input>
                      </template>
                    </el-table-column>
                    <el-table-column prop="selectOption" label="是否上架">
                      <template scope="scope">
                        <el-checkbox
                          @change="
                            checkboxCliock(
                              scope.row.giftSKUID,
                              scope.row.selectOption
                            )
                          "
                          :checked="scope.row.selectOption === 1 ? true : false"
                        ></el-checkbox>
                      </template>
                    </el-table-column>
                    <!-- <el-table-column type="selection">
    </el-table-column> -->
                  </el-table>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="100">
              <el-col :span="9">
                <el-form-item label="吊牌价">
                  <el-input v-model="ruleForm.lblPrice"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="9">
                <el-form-item label="领取方式">
                  <!-- <el-select style="width: 100%"
                             v-model="ruleForm.collectMethod"> -->
                  <!-- <el-option label="到店自取"
                               value="1"> </el-option>
                    <el-option label="快递邮寄"
                               value="2"> </el-option> -->
                  <!-- <el-option v-for="item in options"
                               :key="item.value"
                               :label="item.label"
                               :value="item.value"></el-option>
                  </el-select> -->
                  <el-checkbox-group v-model="ruleForm.collectMethod">
                    <el-checkbox :label="1"> 到店自取</el-checkbox>
                    <el-checkbox :label="2">快递邮寄</el-checkbox>
                  </el-checkbox-group>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="100">
              <el-col :span="9">
                <el-form-item label="领取期限">
                  <el-input
                    v-model="ruleForm.deadLine"
                    style="width: 180px"
                  ></el-input>
                  &nbsp;&nbsp;天
                  <span style="margin-left: 30px; color: blue"
                    >说明：仅限大于1的数字</span
                  >
                </el-form-item>
              </el-col>
              <el-col :span="9">
                <el-form-item label="最大兑换数量">
                  <el-input v-model="ruleForm.maxNum"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="100">
              <el-col :span="9">
                <el-form-item label="兑换日期">
                  <el-row>
                    <el-col :span="11">
                      <el-date-picker
                        type="date"
                        placeholder="开始日期"
                        v-model="ruleForm.startDate"
                        style="width: 100%"
                      ></el-date-picker>
                    </el-col>
                    <el-col class="line" style="text-align: center" :span="2"
                      >至</el-col
                    >
                    <el-col :span="11">
                      <el-date-picker
                        type="date"
                        placeholder="结束日期"
                        v-model="ruleForm.endDate"
                        style="width: 100%"
                      ></el-date-picker>
                    </el-col>
                  </el-row>
                </el-form-item>
              </el-col>
              <el-col :span="9">
                <el-form-item label="兑换积分">
                  <el-input v-model="ruleForm.creditPoint"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="100">
              <el-col :span="9">
                <el-form-item label="限制销售等级">
                  <el-checkbox
                    label="限制"
                    name="type"
                    :indeterminate="isIndeterminate"
                    v-model="ruleForm.allUser"
                    @change="handleCheckAlllevel"
                  >
                  </el-checkbox>
                  <el-checkbox-group
                    v-model="checkedCities"
                    @change="handValuet"
                  >
                    <div style="width: 200px; border: 1px solid #ccc">
                      <div style="margin-left: 20px">
                        <div>
                          <el-checkbox
                            v-for="item in checkList"
                            :key="item.levelID"
                            :label="item.levelID"
                          >
                            {{ item.levelName_cn }}
                          </el-checkbox>
                        </div>
                      </div>
                    </div>
                  </el-checkbox-group>
                </el-form-item>
              </el-col>
              <el-col :span="9">
                <el-form-item label="置顶排序">
                  <el-checkbox-group v-model="ruleForm.top">
                    <div style="display: flex">
                      <el-checkbox label="置顶" name="type"></el-checkbox>
                      <el-input
                        style="margin-left: 10px"
                        v-model="ruleForm.topSortIndex"
                      ></el-input>
                    </div>
                  </el-checkbox-group>
                </el-form-item>
                <el-form-item label="允许兑换维护店" label-width="120px">
                  <el-radio-group v-model="ruleForm.allServShop">
                    <div style="display: flex; align-items: center">
                      <el-radio :label="true">全部门店</el-radio>
                      <el-radio :label="false">部分门店</el-radio>
                      <el-button
                        @click="outletVisible = true"
                        style="
                          height: 35px;
                          line-height: 10px;
                          margin-left: 15px;
                        "
                        :disabled="ruleForm.allServShop"
                        >选择门店</el-button
                      >
                    </div>
                  </el-radio-group>
                  <div style="padding-top: 20px" v-if="!ruleForm.allServShop">
                    <textarea
                      style="width: 100%; margin: 0px; padding: 0px"
                      rows="4"
                      readonly
                      v-model="ruleForm.servOrgListStr"
                    ></textarea>
                  </div>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col>
                <el-form-item label="核销提醒方式">
                  <el-radio-group v-model="ruleForm.pubVeriCoupMode">
                    <el-radio :label="0">不提醒</el-radio>
                    <el-radio :label="1">公众号模板消息</el-radio>
                    <el-radio :label="2">短信消息</el-radio>
                    <el-radio :label="3">公众号模板消息和短信消息 </el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col>
                <el-form-item label="券到期提醒方式">
                  <el-radio-group v-model="ruleForm.expirationMode">
                    <el-radio :label="0">不提醒</el-radio>
                    <el-radio :label="1">公众号模板消息</el-radio>
                    <el-radio :label="2">短信消息</el-radio>
                    <el-radio :label="3">公众号模板消息和短信消息 </el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="100">
              <el-col :span="9">
                <el-form-item label="提前提醒">
                  <el-input
                    style="width: 130px"
                    v-model="ruleForm.expirationTime"
                  ></el-input>
                  &nbsp; &nbsp;天
                </el-form-item>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="18">
                <el-form-item label="领取场所限制">
                  <el-radio-group v-model="ruleForm.siteLimitFlag">
                    <el-radio :label="0">无限制</el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="">
                  <el-radio-group v-model="ruleForm.siteLimitFlag">
                    <el-radio :label="2">城市</el-radio>
                    <el-button @click="citybtn">增加</el-button>
                  </el-radio-group>
                  <el-table
                    size="mini"
                    class="table-style"
                    border
                    :row-class-name="tableRowClassName"
                    :header-cell-style="{
                      background: '#FCFBF2',
                      color: '#6C6839',
                      'text-align': 'center',
                    }"
                    :cell-style="{ 'text-align': 'center' }"
                    ref="multipleTable"
                    :data="city"
                    tooltip-effect="dark"
                  >
                    <el-table-column label width="35" type="index">
                    </el-table-column>
                    <el-table-column prop="siteName" label="城市">
                      <template slot-scope="scope">
                        <el-input v-model="scope.row.siteName"></el-input>
                      </template>
                    </el-table-column>
                    <el-table-column prop="hasStock" label="是否有库存">
                      <template slot-scope="scope">
                        <el-checkbox v-model="scope.row.hasStock"></el-checkbox>
                      </template>
                    </el-table-column>
                    <el-table-column prop="state" label="状态">
                      <template slot-scope="scope">
                        <!-- <el-input v-model="scope.row.state"></el-input> -->
                        <el-checkbox
                          v-model="scope.row.state"
                          :true-label="0"
                          :false-label="1"
                        ></el-checkbox>
                      </template>
                    </el-table-column>
                    <el-table-column prop="name" label="操作">
                      <template slot-scope="scope">
                        <el-button
                          type="text"
                          @click.native.prevent="
                            deletesizeoes(scope.$index, city)
                          "
                          >删除</el-button
                        >
                      </template>
                    </el-table-column>
                  </el-table>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="18">
                <el-form-item label="">
                  <el-radio-group v-model="ruleForm.siteLimitFlag">
                    <el-radio :label="1">门店</el-radio>
                    <el-button @click="shopbtn">增加</el-button>
                  </el-radio-group>
                  <el-table
                    size="mini"
                    class="table-style"
                    border
                    :row-class-name="tableRowClassName"
                    :header-cell-style="{
                      background: '#FCFBF2',
                      color: '#6C6839',
                      'text-align': 'center',
                    }"
                    :cell-style="{ 'text-align': 'center' }"
                    ref="multipleTable"
                    :data="shop"
                    tooltip-effect="dark"
                  >
                    <el-table-column label width="35" type="index">
                    </el-table-column>
                    <el-table-column prop="siteName" label="门店">
                      <template slot-scope="scope">
                        <el-autocomplete
                          v-model="scope.row.siteName"
                          placeholder="请输入门店编号"
                          @select="handleSelect"
                          :fetch-suggestions="querySearch"
                        >
                        </el-autocomplete>
                      </template>
                    </el-table-column>
                    <el-table-column prop="shopName" label="门店名称">
                      <template slot-scope="scope">
                        <el-input v-model="scope.row.shopName"></el-input>
                      </template>
                    </el-table-column>
                    <el-table-column prop="hasStock" label="是否有库存">
                      <template slot-scope="scope">
                        <!-- <el-input v-model="scope.row.accessoriesSize"></el-input> -->
                        <el-checkbox v-model="scope.row.hasStock"></el-checkbox>
                      </template>
                    </el-table-column>
                    <el-table-column prop="state" label="状态">
                      <template slot-scope="scope">
                        <!-- <el-input v-model="scope.row.accessoriesSize"></el-input> -->
                        <el-checkbox
                          v-model="scope.row.state"
                          :true-label="0"
                          :false-label="1"
                        ></el-checkbox>
                      </template>
                    </el-table-column>
                    <el-table-column prop="name" label="操作">
                      <template slot-scope="scope">
                        <el-button
                          type="text"
                          @click.native.prevent="
                            deletesizebtn(scope.$index, shop)
                          "
                          >删除</el-button
                        >
                      </template>
                    </el-table-column>
                  </el-table>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
      </el-card>
      <!-- 选择门店弹窗 -->
      <div class="outlet">
        <el-dialog
          :close-on-click-modal="false"
          width="30%"
          :visible.sync="outletVisible"
          title="选择门店"
        >
          <el-form size="mini" label-width="90px">
            <el-row
              :gutter="50"
              v-for="(item, index) in StoreSelectionList"
              :key="index"
            >
              <el-col
                :span="12"
                v-for="(myitem, myindex) in item"
                :key="myindex"
              >
                <el-tree
                  ref="tree"
                  v-if="myitem != undefined"
                  :data="[myitem]"
                  show-checkbox
                  node-key="shopID"
                  highlight-current
                  default-expand-all
                  :default-checked-keys="xuanzhong"
                  :props="defaultProps"
                >
                </el-tree>
              </el-col>
            </el-row>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="ComButtomStore">确 定</el-button>
            <el-button @click="outletVisible = false">取 消</el-button>
          </div>
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import {
  reserveGIftSku,
  reserveGIftApi,
  couponsGroupApi,
  upperOrLowerinsert,
  upperOrLowerview,
  detailedCapi,
  customerlevelApi,
  imageupadatApi,
} from "@/api/Integralquery";
import { RegionApi } from "@/api/reportForm";
import { shopselectListApi } from "@/api/shop";
import { dateTimes } from "@/utils/auth";
export default {
  name: "centre",
  data() {
    return {
      screenWidth: "",
      ElementHeight: "0px",
      colorcheckList: [], //颜色选中数组
      //图片回显
      imagesArray: [],
      //修改时
      imageClearn: [],

      BoxesList: [], //是否上架选中数组
      innerVisible: false,
      presentVisible: false,
      innerVisibleLier: false,
      labelPosition: "right",
      value1: "",
      checkedCities: [],
      formLabeladd: {},
      //内置弹窗查询以及数据
      Position: {
        pageSize: "50",
        pageNo: "1",
        giftNo: "", //礼品编码
        giftName: "", //礼品名称
      },
      ruleForm: {
        allServShop: true,
        commAllowLvlList: [],
        commodityName: "", //商品名称
        commDetail: "", //商品详情
        startDate: "", //开始时期
        endDate: "", //结束日期
        couponsGrpID: "", //券库 ID
        couponsName: "", //券名称
        maxNum: "", //最大兑换数量
        creditPoint: "", //兑换积分
        expirationMode: "", //到期提醒方式
        pubVeriCoupMode: "", //核销提醒方式
        allUser: "", //限制销售等级
        top: false, //置顶
        topSortIndex: "", //置顶序列号
        expirationTime: "", //到期提醒天数
        commKind: 1,
        giftID: "", //礼品ID
        lblPrice: "", //吊牌价,
        collectMethod: "",
        deadLine: "", //领取期限
        siteLimitFlag: "", //领取场限制
        commodityID: "",
      },
      // 选择门店弹窗
      outletVisible: false,
      regionList: [],
      xuanzhong: [],
      StoreSelectionList: [],
      StoredataArray: [],
      StoreSelectLength: 0,
      defaultProps: {
        children: "chlidren",
        label: "lable",
      },
      foundFormVisible: false,
      //sku数据存放
      SkuList: [],
      //劵库存放
      queryList: [],
      radioes: "",
      //sku
      tCommskustockList: [],
      //
      //限制
      tCommsitelimitList: [],
      //城市
      city: [],
      //门店
      shop: [],
      mySqllist: [],
      //赋值
      handleRadioValue: "",
      radioId: "",
      queryArr: {
        couponsName: "", //卷名称
        couponsKind: "", //卷类型
        createTime: "",
        updateTime: "",
        state: 0,
        pageSize: "50",
        pageNo: "1",
      },
      JuankuRadios: "",
      checkList: [],
      isIndeterminate: false,
      //门店
      shopList: [],
      //颜色数组
      colorList: [],
      //模糊查询接受
      shopArr: [],
      options: [
        {
          value: 1,
          label: "到店自取",
        },
        {
          value: 2,
          label: "快递邮寄",
        },
      ],
      cheboxRey: [],
      //存放图片数组
      imagArray: [],
      imagespush: [],
    };
  },
  created() {
    this.certificatevent();
    this.customermethods();
    this.regionSelectList();
  },
  watch: {
    screenWidth() {
      this.ElementHeight =
        document.querySelector(".cashcreation").offsetWidth + "px";
    },
  },
  mounted() {
    shopselectListApi().then((res) => {
      if (res.message == "success") {
        res.data.forEach((item) => {
          this.shopArr.push({
            value: item.ShopCode,
            name: item.ShopName,
            id: item.ShopID,
          });
        });
      }
    });
    this.getELmentHeight();
  },
  methods: {
    ComButtomStore() {
      this.ruleForm.servOrgList = [];
      this.ruleForm.servOrgListStr = "";
      for (let index = 0; index < this.StoreSelectLength; index++) {
        let item = this.$refs.tree[index].getCheckedNodes();
        if (item.length == this.StoredataArray[index].chlidren.length + 1) {
          this.ruleForm.servOrgList.push(
            ...this.StoredataArray[index].chlidren
          );
        } else {
          this.ruleForm.servOrgList.push(...item);
        }
      }
      this.ruleForm.servOrgList.forEach((item) => {
        this.ruleForm.servOrgListStr += `${item.lable}\n`;
      });
      this.xuanzhong = [];
      for (let i = 0; i < this.ruleForm.servOrgList.length; i++) {
        this.xuanzhong.push(this.ruleForm.servOrgList[i].id);
      }
      this.outletVisible = false;
      console.log(this.ruleForm);
    },
    regionSelectList() {
      RegionApi({ regionID: "" }).then((res) => {
        if (res.success) {
          this.regionList.push({
            id: "",
            lable: "全部区域",
          });
          this.regionList.push(...res.data);

          let arr1 = [],
            arr2 = [];
          res.data.forEach((item) => {
            if (item.chlidren.length > 0) this.StoredataArray.push(item);
          });
          this.StoredataArray.forEach((item, index) => {
            item.chlidren.forEach((item) => {
              item.shopID = item.id;
            });
            this.StoreSelectLength += 1;
            if (index % 2 == 0) {
              arr1.push(item);
            } else {
              arr2.push(item);
            }
          });
          this.StoreSelectionList = arr1.map((key, value) => [
            key,
            arr2[value],
          ]);
        } else {
          this.$message.error(res.message);
        }
      });
    },
    getELmentHeight() {
      this.screenWidth = document.body.clientWidth;
      window.onresize = () => {
        return (() => {
          this.screenWidth = document.body.clientWidth;
        })();
      };
    },
    remoImage(index, index2) {
      let that = this;
      let imgList = that.colorList[index].imgList;
      imgList.splice(index2, 1);
    },
    // 判断如果是单行就变黄色双行是白色
    tableRowClassName({ rowIndex }) {
      if (rowIndex % 2 === 1) {
        return "warning-row";
      }
      return "";
    },
    //sku数据请求
    async reserveGIft() {
      await reserveGIftApi(this.Position).then((res) => {
        this.SkuList = res.data.list;
      });
      // console.log(this.SkuList);
    },
    //点击礼品弹层获取数据
    Earchbtn() {
      this.reserveGIft();
      this.innerVisible = true;
    },
    //radio赋值
    handleRadioChange(val) {

      this.handleRadioValue = val;
    },
    //内置弹窗查询
    Seacharbtn() {
      this.reserveGIft();
    },
    //弹窗赋值
    Eacmentbtn() {
      this.ruleForm.commodityName = this.handleRadioValue.giftName;
      // this.ruleForm.allUser = this.handleRadioValue.giftName;
      this.ruleForm.giftID = this.handleRadioValue.giftID;
      this.imgList = this.handleRadioValue.imgs;
      this.reserveGIftback();
      this.innerVisible = false;
    },
    handleRadioChangeV(val) {
      this.JuankuRadios = val;
    },
    async Securitieslibrary() {
      await couponsGroupApi(this.queryArr).then((res) => {
        this.queryList = res.data.list;
      });
    },
    //劵库查询
    Seachbtn() {
      this.Securitieslibrary();
    },
    //点击劵库获取数据
    SearchJuan() {
      this.Securitieslibrary();
      this.innerVisibleLier = true;
    },
    determine() {
      this.ruleForm.couponsName = this.JuankuRadios.couponsName;
      this.ruleForm.couponsGrpID = this.JuankuRadios.couponsGrpID;
      this.innerVisibleLier = false;
    },
    async reserveGIftback() {
      await reserveGIftSku({ giftID: this.ruleForm.giftID }).then((res) => {
        this.tCommskustockList = res.data;
      });

      let colarArray = [];
      this.colorList = [];
      this.tCommskustockList.map((item) => {
        if (colarArray.indexOf(item.colorName) == -1) {
          colarArray.push(item.colorName);
          item.imgList = []
          this.colorList.push(item);
        }
      });
    },
    async MycoolSku() {
      await reserveGIftSku({ giftID: this.ruleForm.giftID }).then((res) => {
        this.mySqllist = res.data;
      });
    },
    handleCheckAlllevel(val) {
      let arr = [];
      this.checkedCities = val ? arr : [];
      this.checkList.forEach((item) => {
        arr.push(item.levelID);
      });
      this.isIndeterminate = false;
    },
    handValuet(val) {
      let checkedCount = val.length;
      this.isIndeterminate =
        checkedCount < 0 && checkedCount > this.checkList.length;
    },
    //礼品修改
    async Createasave() {
      let arr = [];
      this.checkList.forEach((item) => {
        arr.push(item.levelID);
      });
      this.ruleForm.commAllowLvlList = [];
      for (let i = 0; i < this.checkedCities.length; i++) {
        const item = this.checkedCities[i];

        if (this.ruleForm.allUser === true) {
          this.ruleForm.commAllowLvlList.push({ levelID: item });
        } else {
          console.log("---");
        }
      }
      let querArrback = {
        commAllowLvlList: this.ruleForm.commAllowLvlList,
        commodityName: this.ruleForm.commodityName, //商品名称
        commDetail: this.ruleForm.commDetail, //商品详情
        startDate: dateTimes(this.ruleForm.startDate), //开始时期
        endDate: dateTimes(this.ruleForm.endDate), //结束日期
        couponsGrpID: this.ruleForm.couponsGrpID, //券库 ID
        couponsName: this.ruleForm.couponsName, //券名称
        maxNum: this.ruleForm.maxNum, //最大兑换数量
        creditPoint: this.ruleForm.creditPoint, //兑换积分
        expirationMode: this.ruleForm.expirationMode, //到期提醒方式
        pubVeriCoupMode: this.ruleForm.pubVeriCoupMode, //核销提醒方式
        allUser: this.ruleForm.allUser, //限制销售等级
        top: this.ruleForm.top, //置顶
        topSortIndex: this.ruleForm.topSortIndex, //置顶序列号
        expirationTime: this.ruleForm.expirationTime, //到期提醒天数
        commKind: this.ruleForm.commKind,
        giftskuid: this.tCommskustockList.giftskuid, //礼品ID
        giftID: this.ruleForm.giftID,
        // skuid: this.mySqllist.GiftSKUID,
        lblPrice: this.ruleForm.lblPrice, //吊牌价,
        collectMethod: "",
        deadLine: this.ruleForm.deadLine, //领取期限
        siteLimitFlag: this.ruleForm.siteLimitFlag, //领取场限制
        tCommsitelimitList: [],
        tCommskustockList: [],
        commColorImgList: [],
        commodityID: this.ruleForm.commodityID,
        image1: this.imagesArray[0],
        image2: this.imagesArray[1],
        image3: this.imagesArray[2],
        allServShop: this.ruleForm.allServShop,
        servOrgList: this.ruleForm.allServShop
          ? []
          : this.ruleForm.servOrgList.map((item) => {
              return { shopID: item.shopID };
            }),
      };

      if (this.ruleForm.siteLimitFlag == 2) {
        querArrback.tCommsitelimitList = this.city;
      }
      if (this.ruleForm.siteLimitFlag == 1) {
        this.shop.forEach((item) => {
          querArrback.tCommsitelimitList.push({
            hasStock: item.hasStock,
            siteName: item.siteName,
            state: item.state,
          });
        });
      }
      this.tCommskustockList.forEach((item) => {
        if (item.selectOption === 1) {
          querArrback.tCommskustockList.push(item);
        }
      });
      let data = [];
      console.log(this.colorList)
      this.colorList.forEach((item, i) => {
        data.push({
          colorAttrID: item.colorAttrID,
        });
        if (item.imgList[0]) {
          data[i].image1 = item.imgList[0];
        }
        if (item.imgList[1]) {
          data[i].image2 = item.imgList[1];
        }
        if (item.imgList[2]) {
          data[i].image3 = item.imgList[2];
        }
      });
      if (this.ruleForm.collectMethod.length === 2) {
        querArrback.collectMethod = 3;
      }
      if (this.ruleForm.collectMethod.length === 1) {
        querArrback.collectMethod = this.ruleForm.collectMethod[0];
      }
      if (this.ruleForm.collectMethod.length === 0) {
        querArrback.collectMethod = "";
      }
      querArrback.commColorImgList = data;
      querArrback.allUser = !querArrback.allUser;

      await upperOrLowerinsert(querArrback).then((res) => {
        if (res.message === "success") {
          this.$message.success("复制成功！");
          this.imagesArray = [];
          this.$router.push({
            path: "/Commodity",
          });
        }
      });
    },
    deletesizebtn(index, rowes) {
      rowes.splice(index, 1);
    },
    deletesizeoes(index, rowes) {
      rowes.splice(index, 1);
    },
    //城市添加
    citybtn() {
      let space = {
        SiteName: "",
        State: "",
        isSufficientStock: "",
      };
      if (this.ruleForm.siteLimitFlag === 2) {
        this.city.push(space);
      }
    },
    // 门店增加
    shopbtn() {
      let space = {
        SiteName: "",
        State: "",
        isSufficientStock: "",
      };
      if (this.ruleForm.siteLimitFlag === 1) {
        this.shop.push(space);
      }
    },
    //修改（礼品）回显
    async certificatevent() {
      await upperOrLowerview({ commodityID: this.$route.query.moneyes }).then(
        (res) => {
          this.ruleForm = res.data;
          if (this.ruleForm.collectMethod == 3) {
            this.ruleForm.collectMethod = [1, 2];
          }
          if (this.ruleForm.collectMethod == 1) {
            this.ruleForm.collectMethod = [1];
          }
          if (this.ruleForm.collectMethod == 2) {
            this.ruleForm.collectMethod = [2];
          }
          this.tCommskustockList = res.data.tCommskustockList;
          this.city = res.data.cityList ? res.data.cityList : [];
          this.shop = res.data.shopList ? res.data.shopList : [];
          let colorArray = [];
          res.data.tCommskustockList.map((item) => {
            if (colorArray.indexOf(item.colorName) == -1) {
              colorArray.push(item.colorName);
              item.imgList = [];
              this.colorList.push(item);
            }
          });
          for (let i = 0; i < res.data.commColorImgList.length; i++) {
            let index = colorArray.indexOf(
              res.data.commColorImgList[i].colorAttrName
            );
            if (index != -1) {
              let imgArr = [];
              if (res.data.commColorImgList[i].image1)
                imgArr.push(res.data.commColorImgList[i].image1);
              if (res.data.commColorImgList[i].image2)
                imgArr.push(res.data.commColorImgList[i].image2);
              if (res.data.commColorImgList[i].image3)
                imgArr.push(res.data.commColorImgList[i].image3);
              this.colorList[index];
              this.$set(this.colorList[index], "imgList", imgArr);
            }
          }
          if (this.ruleForm.image1 != null) {
            this.imagesArray.push(this.ruleForm.image1);
          }
          if (this.ruleForm.image2 != null) {
            this.imagesArray.push(this.ruleForm.image2);
          }
          if (this.ruleForm.image3 != null) {
            this.imagesArray.push(this.ruleForm.image3);
          }
          this.ruleForm.servOrgListStr = "";
          this.ruleForm.servOrgList.forEach((item) => {
            this.ruleForm.servOrgListStr += `${item.shopName}\n`;
            this.xuanzhong.push(item.shopID);
          });
          //  域名
          // this.colorList.forEach((item) => {
          //   item.imgList = [];
          //   if (item.image1 != null) {
          //     item.imgList.push(item.image1);
          //   }
          //   if (item.image2 != null) {
          //     item.imgList.push(item.image2);
          //   }
          //   if (item.image3 != null) {
          //     item.imgList.push(item.image3);
          //   }
          // });
          this.ruleForm.allUser = !this.ruleForm.allUser;
        }
      );
      this.ruleForm.commAllowLvlList.forEach((item) => {
        if (item.selectOption === true) {
          this.checkedCities.push(item.levelID);
        }
      });
      this.MycoolSku();
    },
    async handleGoods(val) {
      await detailedCapi({ SKU: val.productSKU }).then((res) => {
        if (res.message == "success") {
          this.formLabeladd = res.data;
        }
        this.foundFormVisible = true;
      });
    },
    //会员等级
    async customermethods() {
      await customerlevelApi().then((res) => {
        this.checkList = res.data;
      });
    },
    // 根据门店编号带出门店名称
    handleSelect(val) {
      this.shop.forEach((item) => {
        item.shopName = val.name;
      });
    },
    //门店编号模糊查询
    querySearch(queryString, cb) {
      var shopList = this.shopArr;
      var results = queryString
        ? shopList.filter(this.createFilter(queryString))
        : shopList;
      // 调用 callback 返回建议列表的数据
      cb(results);
    },
    createFilter(queryString) {
      return (shoplis) => {
        return (
          shoplis.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0
        );
      };
    },
    //连接跳转
    giftDaTeurl() {
      this.$router.push({
        path: "/GiftLookup",
        query: {
          couper: this.JuankuRadios.couponsGrpID,
        },
      });
    },
    clearbtn() {
      this.$router.go(-1);
    },
    handleImportsd(file) {
      const params = new FormData();
      params.append("file", file.file);
      imageupadatApi(params)
        .then((res) => {
          if (res.data) {
            this.imagesArray.push(res.data);
          }
          this.$message.success("上传成功！");
        })
        .catch(() => {
          this.$message.error("上传失败!");
        });
    },
    Imagedeletebtn(index) {
      this.imagesArray.splice(index, 1);
    },
    imageupdate(file) {
      let that = this;
      let colorList = that.colorList;
      if (this.colorList[file.data.index].imgList.length >= 3) {
        this.$message.success("最多上传三张！");
        return false;
      }
      const params = new FormData();
      params.append("file", file.file);
      imageupadatApi(params)
        .then((res) => {
          if (res.data) {
            colorList[file.data.index].imgList.push(res.data);
            this.colorList = colorList;
            this.$forceUpdate();
          }
          this.$message.success("上传成功！");
        })
        .catch(() => {
          this.$message.error("上传失败!");
        });
    },
    checkboxCliock(id, type) {
      this.tCommskustockList.forEach((item) => {
        if (item.giftSKUID == id) {
          item.selectOption = type === 1 ? 0 : 1;
          // console.log(this.tCommskustockList[i].selectOption);
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
/deep/.el-dialog__header {
  padding: 1.25rem 1.25rem 0.625rem;
  background-color: #d1cda5;
}
/deep/.el-dialog__footer {
  height: 60px;
  text-align: center;
  background-color: #f2f2f2;
}
// 按钮边框去掉，文字颜色和加粗
/deep/button {
  border-color: #e6e0af;
  border-radius: 7px;
  color: #a19b59;
}
/deep/input {
  border-radius: 0;
}
// 去除表头复选框
/deep/.table-style {
  .el-table-column--selection.is-leaf .el-checkbox {
    display: none;
  }
}
#giftcreate {
  height: auto;
  padding-bottom: 50px;
}
.header-text {
  position: fixed;
  z-index: 88;
  margin-top: -1.25rem;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-end;
  background-color: #f3f5f7;
  height: 4.5rem;
  color: #76734f;
  padding-bottom: 5px;
}
.card-pagination {
  height: 50px;
}

// input框的圆角取消
/deep/input {
  border-radius: 0 !important;
}
//改变Upload 上传组件大小
/deep/ .el-upload--picture-card {
  width: 100px;
  height: 100px;
}
/deep/ .el-upload {
  width: 100px;
  height: 100px;
  line-height: 100px;
}
/deep/ .el-upload-list--picture-card .el-upload-list__item {
  width: 100px;
  height: 100px;
  line-height: 100px;
}
/deep/ .el-upload-list--picture-card .el-upload-list__item-thumbnail {
  width: 100px;
  height: 100px;
  line-height: 100px;
}
/deep/ .avatar {
  width: 100px;
  height: 100px;
}
::v-deep {
  // 表格隔行变色
  .el-table .warning-row {
    background: #fcfbf2;
  }

  .el-table .success-row {
    background: #ffffff;
  }

  .choice,
  .present {
    .el-dialog__header,
    .el-message-box__header {
      height: 44px;
      background: #f3f1dd;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 20px;
    }
    .el-dialog__title,
    .el-message-box__title {
      color: #6c6937;
      font-weight: 700;
      font-size: 12px !important;
    }

    /* Dialog对话框 公共部分样式 End*/

    .el-tabs__item {
      background-color: #fff;
      color: #6c6937;
    }
    .el-dialog__footer {
      height: 60px;
      text-align: center;
      background-color: #f2f2f2;
    }

    .el-button:hover {
      background-color: #b6b388;
    }
    .el-form-item__content {
      line-height: 0px;
    }

    .el-textarea__inner {
      // 取消拉伸样式
      resize: none;
    }
  }
  .el-table .el-table__cell {
    .el-input--small .el-input__inner {
      border: 0;
      text-align: center;
    }
  }
  .flex-between input.el-input__inner {
    text-decoration: underline;
    color: blue;
  }
}
.cashcreation {
  margin-bottom: 100px;
}
.header-title {
  min-width: 250px;
  line-height: 50px;
  height: 50px;
}
.header-text1 {
  height: 3.5rem;
}
.buttom-div {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-content: flex-end;
  width: 250px;
  height: 50px;
  align-content: center;
}
.push-button {
  width: 100px;
  color: #a19b59;
}
</style>
